var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { message } from 'antd';
import { requestWithCheckVersion, } from './requestWithCheckVersion';
var request = function (method, url, _a) {
    if (_a === void 0) { _a = {}; }
    var withoutLoginRedirect = _a.withoutLoginRedirect, options = __rest(_a, ["withoutLoginRedirect"]);
    var _b = (options === null || options === void 0 ? void 0 : options.params) || {}, _c = _b.showError, showError = _c === void 0 ? true : _c, params = __rest(_b, ["showError"]);
    return requestWithCheckVersion(method, url, __assign(__assign({}, options), { params: params }))
        .then(function (_a) {
        var data = _a.data;
        return data || {};
    })
        .catch(function (err) {
        var _a;
        var _b = (_a = err.response) !== null && _a !== void 0 ? _a : {}, status = _b.status, data = _b.data;
        if (status === 403) {
            if (!withoutLoginRedirect) {
                window.location.replace("/accounts/login/samolet/?next=" + window.location.pathname);
            }
            throw err;
        }
        if (showError) {
            status === 400
                ? data.type === 'invalid' && message.error(String(data.payload))
                : status &&
                    message.error("\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0438 \u043A \u0441\u0435\u0440\u0432\u0435\u0440\u0443: " + status);
        }
        throw err;
    });
};
export var sseRequest = function (url, stopStatuses) {
    var evtSource = new EventSource(url);
    evtSource.addEventListener('message', function (message) {
        var status = JSON.parse(message.data.replace(/[b']/g, '')).status;
        stopStatuses.includes(status) && evtSource.close();
    }, false);
    return evtSource;
};
var clearEmptyParams = function (params) {
    var cleared = {};
    Object.keys(params).forEach(function (key) {
        var isNotEmpty = params[key] !== undefined || params[key] !== null;
        if (isNotEmpty) {
            cleared[key] = params[key];
        }
    });
    return cleared;
};
export var get = function (url, params, config) {
    return request('get', url, __assign(__assign({}, config), { params: params ? clearEmptyParams(params) : undefined }));
};
export var post = function (url, data, config) {
    return request('post', url, __assign(__assign({}, config), { data: data }));
};
export var put = function (url, data, config) {
    return request('put', url, __assign(__assign({}, config), { data: data }));
};
export var patch = function (url, data, config) {
    return request('patch', url, __assign(__assign({}, config), { data: data }));
};
export var del = function (url, data, config) {
    return request('delete', url, __assign(__assign({}, config), { data: data }));
};
export default request;
//# sourceMappingURL=request.js.map